import { useState } from 'react';
import { useAuth } from '../auth';

export function Login() {
  const { login } = useAuth();
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onClick() {
    setErr(null);
    setLoading(true);
    try {
      await login();
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="center">
      <div className="login-card">
        <h2>Backoffice</h2>
        <p>Accede con tu cuenta Google administradora.</p>
        <button className="primary" onClick={onClick} disabled={loading}>
          {loading ? 'Abriendo…' : 'Iniciar sesión con Google'}
        </button>
        {err && <div className="error" style={{ marginTop: 16 }}>{err}</div>}
      </div>
    </div>
  );
}
